import { createAction } from '@reduxjs/toolkit';
import { nameSpace } from '../Modules/nameSpace';

// These action are specific page based actions
// These action are used to call saga and perform some task

const endTask = createAction(`${nameSpace}/endTask`);
const startTask = createAction(`${nameSpace}/startTask`);

export { endTask, startTask };
